import React from 'react';
import { Box, Button, Card, Stack, Switch, Typography } from '@curves/ui-base';
import { Overview } from '@curves/ui-shared';

import { PointsActivityTableMoreLabel } from '@Local/Points/Activity/';
import { usePointsContext } from '@Local/Points/Components/PointsContext';
import { parseDate } from '@Util/moment.util';
import usePointsActivityApi from '@Apis/usePointsActivityApi';
import useMessageDialog from "@Util/hook/useMessageDialog";
const headerRow = [
    {
        cellKey: 'title',
        headerLabel: '活動標題',
        align: 'center',
        style: { minWidth: 50 },
    },
    {
        cellKey: 'description',
        headerLabel: '活動說明',
        align: 'center',
        width: 30,
        style: { minWidth: 50, maxWidth: '30rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
    },
    {
        cellKey: 'startDate',
        headerLabel: '活動時間',
        align: 'center',
        style: { minWidth: 50 },
        formatCell: (value, { endDate }) => {
            return (
                <Stack direction="column">
                    <Typography component="span">{`${parseDate(value)}`}</Typography>
                    <Typography component="span">~</Typography>
                    <Typography component="span">{`${parseDate(endDate)}`}</Typography>
                </Stack>
            );
        },
    },
    {
        cellKey: 'redeemStart',
        headerLabel: '兌換時間',
        align: 'center',
        style: { minWidth: 50 },
        formatCell: (value, { redeemEnd }) => {
            return (
                <Stack direction="column">
                    <Typography component="span">{`${parseDate(value)}`}</Typography>
                    <Typography component="span">~</Typography>
                    <Typography component="span">{`${parseDate(redeemEnd)}`}</Typography>
                </Stack>
            );
        },
    },
    {
        cellKey: 'isVisible',
        headerLabel: '是否開啟',
        align: 'center',
        style: { minWidth: 50 },
        formatCell: (value, rowData, { onSwitchChange }) => {
            return <Switch defaultChecked={value} onChange={(_e, checked) => onSwitchChange(rowData, { isVisible: checked }, rowData.activityID)} />;
        },
    },
    {
        cellKey: '',
        headerLabel: '',
        align: 'center',
        style: { minWidth: 50 },
        formatCell: (_, rowData, { onClick }) => {
            return <PointsActivityTableMoreLabel rowData={rowData} onClick={onClick} />;
        },
    },
];
const PointsActivityTable = (props) => {
    const { sourceData, pageModel, dialogRef, refresh } = usePointsContext();
    const { putPointsActivityOverviewApi, putPointsActivityResetApi } = usePointsActivityApi();
    const setMessageDialog = useMessageDialog();
    const handleAddPointActivityOnClick = () => {
        dialogRef.current.openProductActivityDialog({}, refresh);
    };
    const handleTableMoreLabelOnClick = (type, targetData) => {
        if (type === 'editPointActivity') {
            dialogRef.current.openProductActivityDialog(targetData, refresh);
        } 
        else if (type === 'resetPointActivityItems') {
            setMessageDialog({
                open: true,
                title: '重置點數活動贈品項目',
                msg: `是否要重置[${targetData.title}]點數活動贈品項目？`,
                onAsyncConfirm: (_, onClose) => doResetActivityApi(targetData.activityID, onClose),
            });
        }
    };
    const handleIsVisibleOnChange = (targetData, changeData, activityID) => {
        let params = JSON.parse(JSON.stringify(targetData));
        Object.assign(params, changeData);
        putEditActivityApi(params, activityID);
    };
    const putEditActivityApi = async (params, activityID) => {
        const resp = await putPointsActivityOverviewApi(params, activityID);
        resp && setTimeout(refresh, 5);
    };
    const doResetActivityApi = async (activityID, closeFn) => {
        const resp = await putPointsActivityResetApi({}, activityID);
        resp && setTimeout(refresh, 5);
        closeFn();
    }
    // 沿用 context 的分頁資訊，此頁沒有換頁
    const contextValue = {
        overviewData: {
            list: sourceData,
            pagination: { pageIndex: pageModel.pageIndex, pageSize: pageModel.pageSize, totalCount: pageModel.totalCount, totalPage: pageModel.totalPage ?? 0 },
        },
    };
    return (
        <Card className="py-2">
            <Card.CardContent>
                <Box className="mb-4 px-3">
                    <Button onClick={handleAddPointActivityOnClick} color="info" variant="contained">
                        新增點數活動
                    </Button>
                    <Overview contextValue={contextValue} idKey="activityID">
                        <Stack className="overview__toolbar" alignItems="center" justifyContent="end">
                            <Overview.TotalCount showRange />
                        </Stack>
                        <Overview.Table
                            headerRow={headerRow}
                            cardProps={{ className: 'theme-gray' }}
                            cellWidth={16}
                            isFixed
                            cellRenderContext={{ onClick: handleTableMoreLabelOnClick, onSwitchChange: handleIsVisibleOnChange }}
                        />
                    </Overview>
                </Box>
            </Card.CardContent>
        </Card>
    );
};
export default PointsActivityTable;
